import React from 'react';
import './GalleryPage.css';

const GalleryPage = () => {
  return (
    <div className='galleryPage pb-3'>
      <h3 className="text-center pb-3">Gallery</h3>
      <div className="container">
        <div className="row g-5">
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4241.jpg" alt="Gallery item 1" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4245.jpg" alt="Gallery item 2" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4283.jpg" alt="Gallery item 3" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4295.jpg" alt="Gallery item 4" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4314.jpg" alt="Gallery item 5" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4349.jpg" alt="Gallery item 6" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4389.jpg" alt="Gallery item 7" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4419.jpg" alt="Gallery item 8" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4481.jpg" alt="Gallery item 9" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4499.jpg" alt="Gallery item 10" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4550.jpg" alt="Gallery item 11" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4592.jpg" alt="Gallery item 12" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4612.jpg" alt="Gallery item 13" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4635.jpg" alt="Gallery item 14" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4676.jpg" alt="Gallery item 15" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4682.jpg" alt="Gallery item 16" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4724.jpg" alt="Gallery item 17" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4757.jpg" alt="Gallery item 18" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4806.jpg" alt="Gallery item 19" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4819.jpg" alt="Gallery item 20" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/4861.jpg" alt="Gallery item 21" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/5689.jpg" alt="Gallery item 22" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/5705.jpg" alt="Gallery item 23" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/5708.jpg" alt="Gallery item 24" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/5732.jpg" alt="Gallery item 25" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/5745.jpg" alt="Gallery item 26" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/7983.jpg" alt="Gallery item 27" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/8137.jpg" alt="Gallery item 28" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/8250.jpg" alt="Gallery item 29" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/8293.jpg" alt="Gallery item 30" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/8326.jpg" alt="Gallery item 31" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/8414.jpg" alt="Gallery item 32" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/8426.jpg" alt="Gallery item 33" className="img-fluid rounded" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="p-3 bg-light shadow-lg rounded">
              <img src="/8492.jpg" alt="Gallery item 34" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryPage;
